import { render, staticRenderFns } from "./MarketsFilterBadge.vue?vue&type=template&id=6322e39c&"
import script from "./MarketsFilterBadge.vue?vue&type=script&lang=js&"
export * from "./MarketsFilterBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports